module.exports = __webpack_public_path__ + "media/honey-icons/icon-white-label-camera-5659123c.svg";